import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="landing-container-full">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <svg width="32" height="32" viewBox="0 0 32 32" className="logo-icon">
                <defs>
                  <linearGradient id="footerLogoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#3b82f6" />
                    <stop offset="100%" stopColor="#1d4ed8" />
                  </linearGradient>
                </defs>
                <rect x="4" y="4" width="24" height="24" rx="4" fill="url(#footerLogoGradient)" />
                <path d="M12 8l-2 2 1.5 1.5L10 13l2 2 1.5-1.5L15 15l2-2-1.5-1.5L17 10l-2-2-1.5 1.5L12 8z" fill="white" />
                <path d="M18 18l2 2v4l-2-2-4-4 2-2h2z" fill="white" opacity="0.8" />
                <circle cx="21" cy="11" r="2" fill="white" opacity="0.6" />
                <path d="M21 9v4M19 11h4" stroke="white" strokeWidth="0.5" opacity="0.6" />
              </svg>
              <span className="footer-logo-text">Utility Tools</span>
            </div>
            <p className="footer-description">
              Professional PDF tools that work entirely in your browser. Convert files and edit PDFs with complete privacy and security.
            </p>
          </div>

          {/* Quick Links Grid */}
          <div className="footer-links-grid">
            <div className="footer-column">
              <h4 className="footer-column-title">PDF Tools</h4>
              <nav className="footer-nav">
                <a href="#converter" className="footer-link">
                  <span className="link-icon">📄</span>
                  PDF Converter
                </a>
                <a href="#page-remover" className="footer-link">
                  <span className="link-icon">🗑️</span>
                  Page Remover
                </a>
              </nav>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Learn</h4>
              <nav className="footer-nav">
                <a href="/#features" className="footer-link">Features</a>
                <a href="/#how-it-works" className="footer-link">How It Works</a>
                <a href="/#comparison" className="footer-link">Comparison</a>
              </nav>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Support</h4>
              <nav className="footer-nav">
                <a href="#faq" onClick={(e) => { e.preventDefault(); window.location.hash = 'faq'; }} className="footer-link">
                  FAQ
                </a>
                <a href="#feedback" onClick={(e) => { e.preventDefault(); window.location.hash = 'feedback'; }} className="footer-link">
                  Feedback
                </a>
              </nav>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Supported File Formats</h4>
              <div className="footer-formats-simple">
                <div className="format-tags-simple">
                  <span className="format-tag-simple">JPG</span>
                  <span className="format-tag-simple">PNG</span>
                  <span className="format-tag-simple">GIF</span>
                  <span className="format-tag-simple">BMP</span>
                  <span className="format-tag-simple">DOCX</span>
                  <span className="format-tag-simple">TXT</span>
                  <span className="format-tag-simple">HTML</span>
                  <span className="format-tag-simple">MD</span>
                  <span className="format-tag-simple">XLSX</span>
                  <span className="format-tag-simple">XLS</span>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Utility Tools. All rights reserved.
            </p>
            <p className="powered-by-text">Powered by nkcodescribbler</p>
            <div className="legal-links">
              <a href="#privacy" onClick={(e) => { e.preventDefault(); window.location.hash = 'privacy'; }}>Privacy Policy</a>
              <span className="separator">•</span>
              <a href="#privacy" onClick={(e) => { e.preventDefault(); window.location.hash = 'privacy'; }}>Terms of Service</a>
              <span className="separator">•</span>
              <a href="#privacy" onClick={(e) => { e.preventDefault(); window.location.hash = 'privacy'; }}>Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;